import { initializeApp } from "firebase/app";
import { getAuth } from 'firebase/auth';

// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyB_h3aOrRzWHn-YsbmncOR0GPgcXab0tyQ",
  authDomain: "forked-prod.firebaseapp.com",
  projectId: "forked-prod",
  storageBucket: "forked-prod.firebasestorage.app",
  messagingSenderId: "657517558",
  appId: "1:657517558:web:08c15674d0a24d0021b5d7",
  measurementId: "G-3X6GL9BR1H"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Export Firebase Auth
const auth = getAuth(app);
export { auth };